export const lerp = (a, b, i) => (a * i) + (b * (1-i))
